import WORKSPACE_ICONS from './workspaceIconIds.json'

export { WORKSPACE_ICONS }

export const WORKSPACE_EMOJIS = ['🕵🏼‍♀️', '💼', '🚀', '✨', '📊', '🏠']

export const WORKSPACE_ACCENTS = [
  { id: 'slate', label: 'Slate', color: '#64748b' },
  { id: 'blue', label: 'Blue', color: '#2563eb' },
  { id: 'violet', label: 'Violet', color: '#7c3aed' },
  { id: 'rose', label: 'Rose', color: '#e11d48' },
  { id: 'amber', label: 'Amber', color: '#d97706' },
  { id: 'teal', label: 'Teal', color: '#0d9488' },
]

export function workspaceIconLabel(id) {
  return String(id).replace(/-/g, ' ').replace(/\b\w/g, (char) => char.toUpperCase())
}

export function workspaceInitials(name) {
  const parts = String(name || '')
    .trim()
    .split(/\s+/)
    .filter(Boolean)
  if (!parts.length) return 'WS'
  if (parts.length === 1) return parts[0].slice(0, 2).toUpperCase()
  return `${parts[0][0]}${parts[1][0]}`.toUpperCase()
}

export function accentColor(accentId) {
  return WORKSPACE_ACCENTS.find((item) => item.id === accentId)?.color ?? '#64748b'
}
